import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "step-card-header" }
const _hoisted_2 = { class: "step-card-left" }
const _hoisted_3 = { class: "step-card-right" }
const _hoisted_4 = {
  key: 0,
  class: "file-tag"
}
const _hoisted_5 = { class: "upload-area" }
const _hoisted_6 = { class: "upload-icon-wrap" }
const _hoisted_7 = { class: "step-actions" }
const _hoisted_8 = { class: "json-editor" }
const _hoisted_9 = { class: "json-toolbar" }
const _hoisted_10 = { class: "json-meta" }
const _hoisted_11 = { class: "json-body" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "step-card-header" }
const _hoisted_14 = { class: "step-card-left" }
const _hoisted_15 = { class: "step-card-right" }
const _hoisted_16 = { class: "fancy-tab-label" }
const _hoisted_17 = { class: "step-actions export-actions" }
const _hoisted_18 = { class: "upload-area" }
const _hoisted_19 = { class: "upload-icon-wrap" }
const _hoisted_20 = { class: "upload-text" }
const _hoisted_21 = { class: "step-actions" }
const _hoisted_22 = {
  key: 0,
  class: "upload-success-hint"
}
const _hoisted_23 = { class: "fancy-tab-label" }
const _hoisted_24 = {
  key: 0,
  class: "online-editor-loading"
}
const _hoisted_25 = {
  key: 1,
  class: "online-editor"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "sheet-index" }
const _hoisted_28 = { class: "sheet-name" }
const _hoisted_29 = { class: "sheet-rows" }
const _hoisted_30 = { class: "sheet-panel" }
const _hoisted_31 = { class: "sheet-panel-header" }
const _hoisted_32 = { class: "sheet-panel-title" }
const _hoisted_33 = { class: "sheet-panel-name" }
const _hoisted_34 = { class: "sheet-table" }
const _hoisted_35 = ["colspan"]
const _hoisted_36 = {
  key: 1,
  class: "col-source"
}
const _hoisted_37 = {
  key: 0,
  class: "code-row"
}
const _hoisted_38 = { class: "locked" }
const _hoisted_39 = { class: "locked" }
const _hoisted_40 = { class: "row-key" }
const _hoisted_41 = { class: "locked" }
const _hoisted_42 = { class: "locked" }
const _hoisted_43 = { class: "step-actions edit-actions" }
const _hoisted_44 = { class: "parse-bar" }
const _hoisted_45 = { class: "parse-bar-status" }
const _hoisted_46 = { class: "parse-bar-actions" }
const _hoisted_47 = { class: "json-editor" }
const _hoisted_48 = { class: "json-toolbar" }
const _hoisted_49 = { class: "json-meta" }
const _hoisted_50 = { class: "json-body" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "step-card-header" }
const _hoisted_53 = { class: "step-card-left" }
const _hoisted_54 = { class: "step-card-right" }
const _hoisted_55 = { class: "send-step-body" }

import { ref, onMounted, nextTick, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import {
  UploadFilled,
  Loading,
  Download,
  EditPen,
  Check,
  CircleCheck,
  Warning,
  InfoFilled,
} from "@element-plus/icons-vue";
import type { UploadFile } from "element-plus";
import {
  uploadCcsFileApi,
  sendCcsReportApi,
  uploadCcsFileRawApi,
  parseCcsFileApi,
  parseDynamicOnlineApi,
  downloadDynamicTemplateApi,
  fetchDynamicTemplateJsonApi,
  type TemplateSheet,
} from "@/api/operation/ccsReportApi";
import gsap from "gsap";

const VERSION = 2025;
const AUTHOR = "锐深科技";

// ======================== 静态协议 ========================

export default /*@__PURE__*/_defineComponent({
  __name: 'CcsReportView',
  setup(__props) {

const router = useRouter();

// ======================== GSAP Refs ========================
const pageRef = ref<HTMLElement>();
const titleRef = ref<HTMLElement>();
const infoBarRef = ref<HTMLElement>();
const stepperRef = ref<HTMLElement>();
const staticStepRef = ref<HTMLElement>();
const templateStepRef = ref<HTMLElement>();
const dynamicStepRef = ref<HTMLElement>();

// ======================== 固定参数 ========================
const staticFile = ref<File | null>(null);
const staticFilePath = ref("");
const staticUploaded = ref(false);
const staticUploading = ref(false);
const staticParsing = ref(false);
const staticParsedData = ref<Record<string, any> | null>(null);
const staticPreviewVisible = ref(false);
const staticPreviewRef = ref<HTMLElement>();

/** 从静态协议解析结果中提取的 shipId，用于动态协议解析 */
const extractedShipId = ref("");

const handleStaticFileChange = (file: UploadFile) => {
  if (file && file.raw) {
    staticFile.value = file.raw;
    staticFilePath.value = "";
    staticUploaded.value = false;
    staticParsedData.value = null;
    extractedShipId.value = "";
  }
};
const handleStaticFileRemove = () => {
  staticFile.value = null;
  staticFilePath.value = "";
  staticUploaded.value = false;
  staticParsedData.value = null;
  extractedShipId.value = "";
};

const uploadStaticFile = async () => {
  if (!staticFile.value) return;
  staticUploading.value = true;
  try {
    const result = await uploadCcsFileApi(staticFile.value, "static", {
      version: VERSION,
      author: AUTHOR,
    });
    if (result) {
      staticFilePath.value = result.filePath;
      staticParsedData.value = result.parsedData;
      staticUploaded.value = true;
      const shipIdFromHeader =
        result.parsedData?.Package?.Header?.ShipID ||
        result.parsedData?.package?.Header?.ShipID ||
        "";
      extractedShipId.value = String(shipIdFromHeader);
      ElMessage.success("静态协议上传并解析成功");
      await nextTick();
      animateStepDone(staticStepRef.value);
    } else {
      ElMessage.error("文件上传或解析失败");
    }
  } finally {
    staticUploading.value = false;
  }
};

const toggleStaticPreview = async () => {
  staticPreviewVisible.value = !staticPreviewVisible.value;
  await nextTick();
  if (staticPreviewVisible.value) {
    animatePreview(staticPreviewRef.value);
    updateLineNumbers(staticPreviewRef.value);
  }
};

// ======================== 动态协议 ========================
const dynamicFile = ref<File | null>(null);
const dynamicFilePath = ref("");
const dynamicUploaded = ref(false);
const dynamicUploading = ref(false);
const dynamicParsing = ref(false);
const dynamicParsedData = ref<Record<string, any> | null>(null);
const templateDownloading = ref(false);
// 在线编辑相关
const templateTab = ref<"export" | "edit">("export");
const templateLoading = ref(false);
const templateSheets = ref<TemplateSheet[]>([]);
// 缓存原始模板（深拷贝），用于「重置本页 / 重置全部」时不再请求后端
const templateSheetsCache = ref<TemplateSheet[]>([]);
const onlineEditConfirmed = ref(false); // 在线编辑「确定」后置位
const activeSheetIdx = ref(0);
const sheetItemEls = ref<HTMLElement[]>([]);
const sheetListRef = ref<HTMLElement>();
const sheetTableRef = ref<HTMLElement>();
const exportPaneRef = ref<HTMLElement>();
const editPaneRef = ref<HTMLElement>();

// 解析协议相关
const parseLoading = ref(false);
const parseSuccess = ref(false);
// 发送结果
const sendSuccess = ref(false);

// 可以解析的条件：xlsx tab 下文件已上传，或 edit tab 下规则已确定
const canParse = computed(() => {
  if (templateTab.value === "export") {
    return !!dynamicFilePath.value;
  }
  return onlineEditConfirmed.value;
});

// Step2 总体是否已就绪（解析成功）
const dynamicParsedReady = computed(() => parseSuccess.value);

const step2StatusLabel = computed(() => {
  if (parseSuccess.value) return "解析成功";
  if (parseLoading.value) return "解析中";
  if (canParse.value) return "待解析";
  return "未准备";
});

const activeSheet = computed<TemplateSheet | null>(
  () => templateSheets.value[activeSheetIdx.value] ?? null
);

// Sheet 列表左侧 active 指示条样式（GSAP 接管）
const sheetIndicatorStyle = ref<Record<string, string>>({
  transform: "translateY(0px)",
  height: "0px",
  opacity: "0",
});

// 计算每列输入框最小宽度（取该列所有 source/code 文本最大字符数）
const cellWidthStyle = (colIdx: number) => {
  const sheet = activeSheet.value;
  if (!sheet) return {};
  let maxLen = 8;
  if (sheet.codes && sheet.codes[colIdx]) {
    maxLen = Math.max(maxLen, sheet.codes[colIdx].length);
  }
  for (const row of sheet.rows) {
    const v = row.sources[colIdx];
    if (v && v.length > maxLen) maxLen = v.length;
  }
  // 8px / 字符 + 24px padding
  const w = Math.min(Math.max(maxLen * 9 + 24, 110), 360);
  return { minWidth: `${w}px` };
};

const dynamicPreviewVisible = ref(false);
const dynamicPreviewRef = ref<HTMLElement>();

const handleDynamicFileChange = (file: UploadFile) => {
  if (file && file.raw) {
    dynamicFile.value = file.raw;
    dynamicFilePath.value = "";
    dynamicUploaded.value = false;
    dynamicParsedData.value = null;
  }
};
const handleDynamicFileRemove = () => {
  dynamicFile.value = null;
  dynamicFilePath.value = "";
  dynamicUploaded.value = false;
  dynamicParsedData.value = null;
};

const uploadDynamicFile = async () => {
  if (!dynamicFile.value) return;
  dynamicUploading.value = true;
  try {
    const filePath = await uploadCcsFileRawApi(dynamicFile.value, "dynamic");
    if (filePath) {
      dynamicFilePath.value = filePath;
      dynamicUploaded.value = true;
      // 一旦重新上传，需要重新解析
      parseSuccess.value = false;
      dynamicParsedData.value = null;
      dynamicPreviewVisible.value = false;
      ElMessage.success("动态协议文件上传成功，可点击「解析协议」");
    } else {
      ElMessage.error("文件上传失败");
    }
  } finally {
    dynamicUploading.value = false;
  }
};

// 下载动态协议模板 xlsx（导出按钮）
const downloadDynamicTemplate = async () => {
  if (!staticUploaded.value) {
    ElMessage.warning("请先上传静态协议");
    return;
  }
  templateDownloading.value = true;
  try {
    const blob = await downloadDynamicTemplateApi(
      staticParsedData.value ?? undefined
    );
    if (!blob) {
      ElMessage.error("模板下载失败");
      return;
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "CCS动态协议模板.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    ElMessage.success("模板已下载");
  } catch (e) {
    ElMessage.error("模板下载失败");
  } finally {
    templateDownloading.value = false;
  }
};

// ======================== Step2 在线编辑 ========================
const setSheetItemRef = (el: any, idx: number) => {
  if (el) sheetItemEls.value[idx] = el as HTMLElement;
};

// 数据类型 → Tag 颜色
const typeTagType = (
  type: string
): "primary" | "success" | "warning" | "info" | "danger" => {
  if (!type) return "info";
  if (type.startsWith("FA") || type.startsWith("IA")) return "warning";
  if (type.startsWith("F") || type.startsWith("D")) return "success";
  if (type === "I") return "primary";
  if (type === "S") return "info";
  return "info";
};

// Tab 切换：触发对应 Pane 的入场动画；首次进入"在线编辑"时拉取模板
const onTemplateTabChange = async (tabName: string | number) => {
  await nextTick();
  if (tabName === "edit") {
    if (!templateSheets.value.length) await loadTemplateJson();
    animatePane(editPaneRef.value, "right");
    await nextTick();
    moveSheetIndicator(false);
    animateSheetRowsIn();
  } else {
    animatePane(exportPaneRef.value, "left");
  }
};

// 拉取模板 JSON 并同时缓存原始数据（深拷贝）
const loadTemplateJson = async () => {
  templateLoading.value = true;
  try {
    const data = await fetchDynamicTemplateJsonApi(
      staticParsedData.value ?? undefined
    );
    if (data) {
      templateSheets.value = JSON.parse(JSON.stringify(data));
      templateSheetsCache.value = JSON.parse(JSON.stringify(data));
      activeSheetIdx.value = 0;
    } else {
      ElMessage.error("模板加载失败");
    }
  } finally {
    templateLoading.value = false;
  }
};

// 重置本页（不请求后端，从缓存恢复当前 sheet）
const resetCurrentSheet = () => {
  if (!templateSheetsCache.value.length) return;
  const idx = activeSheetIdx.value;
  templateSheets.value[idx] = JSON.parse(
    JSON.stringify(templateSheetsCache.value[idx])
  );
  // 重置后已确定状态失效
  onlineEditConfirmed.value = false;
  parseSuccess.value = false;
  ElMessage.success(`已重置 ${templateSheets.value[idx].name} 页`);
  nextTick(() => animateSheetRowsIn());
};

// 重置全部（不请求后端，从缓存恢复全部 sheet）
const resetAllSheets = () => {
  if (!templateSheetsCache.value.length) return;
  templateSheets.value = JSON.parse(JSON.stringify(templateSheetsCache.value));
  onlineEditConfirmed.value = false;
  parseSuccess.value = false;
  ElMessage.success("已重置全部规则为默认");
  nextTick(() => {
    moveSheetIndicator(false);
    animateSheetRowsIn();
  });
};

// 切换左侧 Sheet
const switchSheet = (idx: number) => {
  if (idx === activeSheetIdx.value) return;
  const dir = idx > activeSheetIdx.value ? 1 : -1;
  activeSheetIdx.value = idx;
  moveSheetIndicator(true);
  // 右侧表格做翻页效果
  nextTick(() => {
    if (sheetTableRef.value) {
      gsap.fromTo(
        sheetTableRef.value,
        { x: dir * 36, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.45, ease: "power3.out" }
      );
    }
    animateSheetRowsIn();
  });
};

// 左侧高亮指示条移动
const moveSheetIndicator = (animate: boolean) => {
  const el = sheetItemEls.value[activeSheetIdx.value];
  if (!el || !sheetListRef.value) return;
  const top = el.offsetTop;
  const height = el.offsetHeight;
  if (animate) {
    gsap.to(sheetIndicatorStyle.value, {
      onUpdate: () => {
        sheetIndicatorStyle.value = { ...sheetIndicatorStyle.value };
      },
      duration: 0.4,
      ease: "power3.out",
    });
  }
  sheetIndicatorStyle.value = {
    transform: `translateY(${top}px)`,
    height: `${height}px`,
    opacity: "1",
  };
};

// 表格行依次入场
const animateSheetRowsIn = () => {
  if (!sheetTableRef.value) return;
  const rows = sheetTableRef.value.querySelectorAll("tbody tr");
  if (!rows.length) return;
  gsap.fromTo(
    rows,
    { y: 12, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 0.35,
      stagger: 0.025,
      ease: "power2.out",
    }
  );
};

// Tab Pane 入场
const animatePane = (el: HTMLElement | undefined, from: "left" | "right") => {
  if (!el) return;
  gsap.fromTo(
    el,
    { x: from === "right" ? 30 : -30, opacity: 0 },
    { x: 0, opacity: 1, duration: 0.4, ease: "power3.out" }
  );
};

// 在线编辑「确定」按钮
const confirmOnlineEdit = () => {
  if (!templateSheets.value.length) {
    ElMessage.warning("模板未加载");
    return;
  }
  onlineEditConfirmed.value = true;
  // 已确定，但解析需要单独点击
  parseSuccess.value = false;
  dynamicParsedData.value = null;
  dynamicPreviewVisible.value = false;
  ElMessage.success("在线编辑已确定，请点击「解析协议」");
};

// 解析协议按钮（统一入口）
const parseProtocol = async () => {
  if (!canParse.value) return;
  if (!extractedShipId.value) {
    ElMessage.error("无法获取船舶ID（请先上传静态协议）");
    return;
  }
  parseLoading.value = true;
  parseSuccess.value = false;
  dynamicParsedData.value = null;
  dynamicPreviewVisible.value = false;
  try {
    let parsed: Record<string, any> | null = null;
    if (templateTab.value === "export") {
      // 走 xlsx 解析
      parsed = await parseCcsFileApi({
        filePath: dynamicFilePath.value,
        protocol: "dynamic",
        shipId: extractedShipId.value,
        version: VERSION,
        author: AUTHOR,
      });
    } else {
      // 走在线规则解析
      parsed = await parseDynamicOnlineApi({
        sheets: templateSheets.value,
        shipId: extractedShipId.value,
        version: VERSION,
        author: AUTHOR,
      });
    }
    if (parsed) {
      dynamicParsedData.value = parsed;
      parseSuccess.value = true;
      ElMessage.success("协议解析成功，可发送报文");
      await nextTick();
      animateStepDone(templateStepRef.value);
    } else {
      ElMessage.error("协议解析失败");
    }
  } catch (e) {
    ElMessage.error("协议解析失败");
  } finally {
    parseLoading.value = false;
  }
};

const toggleDynamicPreview = async () => {
  dynamicPreviewVisible.value = !dynamicPreviewVisible.value;
  await nextTick();
  if (dynamicPreviewVisible.value) {
    animatePreview(dynamicPreviewRef.value);
    updateLineNumbers(dynamicPreviewRef.value);
  }
};

// ======================== 全局发送 ========================
const sending = ref(false);
const isWaitingVisible = ref(false);

const sendReport = async () => {
  if (!parseSuccess.value || !dynamicParsedData.value) return;
  sending.value = true;
  isWaitingVisible.value = true;
  try {
    const success = await sendCcsReportApi({
      packageData: dynamicParsedData.value,
      shipId: extractedShipId.value,
    });
    isWaitingVisible.value = false;
    if (success) {
      sendSuccess.value = true;
      ElMessage.success("报文发送成功");
      await nextTick();
      animateStepDone(dynamicStepRef.value);
    } else {
      ElMessage.error("报文发送失败");
    }
  } finally {
    sending.value = false;
  }
};

// ======================== JSON 格式化与语法高亮 ========================
/**
 * 自定义 JSON 格式化：对象缩进，数组单行显示（逗号后加空格）
 */
function formatJson(data: any, indent = 0): string {
  if (data === null) return "null";
  if (typeof data !== "object") return JSON.stringify(data);

  const pad = "  ".repeat(indent);
  const padInner = "  ".repeat(indent + 1);

  if (Array.isArray(data)) {
    if (data.length === 0) return "[]";
    const items = data.map((item) => {
      if (item === null) return "null";
      if (typeof item === "object") return formatJson(item, indent + 1);
      return highlightToken(JSON.stringify(item));
    });
    return `[${items.join(", ")}]`;
  }

  const entries = Object.entries(data as Record<string, any>);
  if (entries.length === 0) return "{}";
  const lines = entries.map(([key, val]) => {
    let formattedVal: string;
    if (val === null) {
      formattedVal = '<span class="json-null">null</span>';
    } else if (Array.isArray(val)) {
      formattedVal = formatJson(val, indent + 1);
    } else if (typeof val === "object") {
      formattedVal = formatJson(val, indent + 1);
    } else {
      formattedVal = highlightToken(JSON.stringify(val));
    }
    const keySpan = `<span class="json-key">"${escapeHtml(key)}"</span>`;
    return `${padInner}${keySpan}: ${formattedVal}`;
  });
  return `{\n${lines.join(",\n")}\n${pad}}`;
}

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function highlightToken(raw: string): string {
  if (raw === undefined) return "";
  if (raw === "null") return '<span class="json-null">null</span>';
  if (raw === "true" || raw === "false")
    return `<span class="json-boolean">${raw}</span>`;
  if (/^-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?$/.test(raw))
    return `<span class="json-number">${raw}</span>`;
  return `<span class="json-string">${raw}</span>`;
}

function highlightJson(data: Record<string, any> | null): string {
  if (!data) return "";
  return formatJson(data, 0);
}

function jsonLineCount(data: Record<string, any> | null): number {
  if (!data) return 0;
  return JSON.stringify(data, null, 2).split("\n").length;
}

function copyJson(data: Record<string, any> | null) {
  if (!data) return;
  // 复制纯文本格式（带数组单行），strip HTML 标签
  const tmp = document.createElement("div");
  tmp.innerHTML = highlightJson(data);
  const text = tmp.textContent || tmp.innerText || "";
  navigator.clipboard.writeText(text).then(() => {
    ElMessage.success("已复制到剪贴板");
  });
}

function updateLineNumbers(container: HTMLElement | undefined) {
  if (!container) return;
  const codeEl = container.querySelector(".json-code");
  const lineNumEl = container.querySelector(".json-line-numbers");
  if (!codeEl || !lineNumEl) return;
  const lines = (codeEl.textContent || "").split("\n").length;
  lineNumEl.innerHTML = Array.from(
    { length: lines },
    (_, i) => `<span>${i + 1}</span>`
  ).join("");
}

function animatePreview(el: HTMLElement | undefined) {
  if (!el) return;
  gsap.fromTo(
    el,
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0, duration: 0.4, ease: "power3.out" }
  );
}

function animateStepDone(el: HTMLElement | undefined) {
  if (!el) return;
  gsap.to(el, {
    borderColor: "rgba(103, 194, 58, 0.5)",
    boxShadow:
      "0 0 0 1px rgba(103, 194, 58, 0.3), 0 4px 20px rgba(103, 194, 58, 0.1)",
    duration: 0.5,
    ease: "power2.out",
    yoyo: true,
    repeat: 1,
    onComplete: () => {
      gsap.set(el, {
        borderColor: "",
        boxShadow: "",
      });
    },
  });
}

// ======================== 入场动画 ========================
function playEntrance() {
  const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

  if (titleRef.value) {
    tl.fromTo(
      titleRef.value,
      { opacity: 0, y: -20 },
      { opacity: 1, y: 0, duration: 0.4 }
    );
  }
  if (infoBarRef.value) {
    tl.fromTo(
      infoBarRef.value,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.35 },
      "-=0.15"
    );
  }
  if (stepperRef.value) {
    tl.fromTo(
      stepperRef.value,
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 0.4 },
      "-=0.15"
    );
  }

  const steps = [
    staticStepRef.value,
    templateStepRef.value,
    dynamicStepRef.value,
  ].filter(Boolean);
  gsap.set(steps, { opacity: 0, y: 30 });
  tl.to(
    steps,
    { opacity: 1, y: 0, duration: 0.45, stagger: 0.12, ease: "power3.out" },
    "-=0.1"
  );

  const allCards = pageRef.value?.querySelectorAll(".anim-card");
  allCards?.forEach((card) => {
    const el = card as HTMLElement;
    el.addEventListener("mouseenter", () => {
      gsap.to(el, {
        y: -2,
        boxShadow: "0 6px 24px rgba(0,0,0,0.07)",
        duration: 0.2,
        ease: "power2.out",
      });
    });
    el.addEventListener("mouseleave", () => {
      gsap.to(el, {
        y: 0,
        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
        duration: 0.2,
        ease: "power2.out",
      });
    });
  });
}

watch(staticParsedData, async () => {
  await nextTick();
  updateLineNumbers(staticPreviewRef.value);
});
watch(dynamicParsedData, async () => {
  await nextTick();
  updateLineNumbers(dynamicPreviewRef.value);
});

onMounted(() => {
  nextTick(() => playEntrance());
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "pageRef",
    ref: pageRef,
    class: "ccs-report"
  }, [
    _createElementVNode("div", {
      ref_key: "titleRef",
      ref: titleRef,
      class: "page-header"
    }, [
      _createElementVNode("i", {
        class: "iconfont icon-arrow_a",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }),
      _cache[5] || (_cache[5] = _createElementVNode("h1", null, "CCS 报文发送", -1))
    ], 512),
    _createElementVNode("div", {
      ref_key: "infoBarRef",
      ref: infoBarRef,
      class: "info-bar anim-card"
    }, [...(_cache[6] || (_cache[6] = [
      _createStaticVNode("<div class=\"info-item\" data-v-31087bac><span class=\"info-label\" data-v-31087bac>版本号</span><span class=\"info-value locked\" data-v-31087bac>2025</span></div><div class=\"info-divider\" data-v-31087bac></div><div class=\"info-item\" data-v-31087bac><span class=\"info-label\" data-v-31087bac>报送方</span><span class=\"info-value locked\" data-v-31087bac>锐深科技</span></div>", 3)
    ]))], 512),
    _createElementVNode("div", {
      ref_key: "stepperRef",
      ref: stepperRef,
      class: "stepper"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["step-line", { active: staticUploaded.value }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step-line", { active: parseSuccess.value }])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step-node", { done: staticUploaded.value, current: !staticUploaded.value }])
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("div", { class: "step-circle" }, "1", -1),
        _createElementVNode("span", { class: "step-label" }, "静态协议", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step-node", {
          done: parseSuccess.value,
          current: staticUploaded.value && !parseSuccess.value,
        }])
      }, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "step-circle" }, "2", -1),
        _createElementVNode("span", { class: "step-label" }, "动态协议", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["step-node", {
          done: sendSuccess.value,
          current: parseSuccess.value && !sendSuccess.value,
        }])
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("div", { class: "step-circle" }, "3", -1),
        _createElementVNode("span", { class: "step-label" }, "发送报文", -1)
      ]))], 2)
    ], 512),
    _createElementVNode("div", {
      ref_key: "staticStepRef",
      ref: staticStepRef,
      class: "step-card anim-card"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(["step-status-dot", staticUploaded.value ? 'dot-success' : 'dot-pending'])
          }, null, 2),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "step-card-title" }, "Step 1", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "step-card-desc" }, "上传静态协议 xlsx 文件", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          (staticFile.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(staticFile.value.name), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["status-tag", staticUploaded.value ? 'tag-success' : 'tag-idle'])
          }, _toDisplayString(staticUploaded.value ? "已上传" : "未上传"), 3)
        ])
      ]),
      _createVNode(_component_el_upload, {
        class: "ccs-upload",
        drag: "",
        accept: ".xls,.xlsx",
        "on-change": (file) => handleStaticFileChange(file),
        "on-remove": handleStaticFileRemove,
        "auto-upload": false,
        limit: 1
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_icon, { size: 32 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UploadFilled))
                ]),
                _: 1
              })
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "upload-text" }, "拖拽或点击上传静态协议文件", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "upload-hint" }, ".xlsx / .xls", -1))
          ])
        ]),
        _: 1
      }, 8, ["on-change"]),
      _createElementVNode("div", _hoisted_7, [
        (staticFile.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: staticUploading.value,
              onClick: uploadStaticFile
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" 上传文件 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          disabled: !staticUploaded.value || !staticParsedData.value,
          onClick: toggleStaticPreview
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(staticPreviewVisible.value ? "收起解析结果" : "查看解析结果"), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode(_Transition, { name: "preview-expand" }, {
        default: _withCtx(() => [
          (staticParsedData.value && staticPreviewVisible.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "staticPreviewRef",
                ref: staticPreviewRef,
                class: "json-preview-wrap"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "json-dot red" }, null, -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "json-dot yellow" }, null, -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "json-dot green" }, null, -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "json-filename" }, "static-protocol.json", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(jsonLineCount(staticParsedData.value)) + " 行", 1),
                    _createVNode(_component_el_button, {
                      class: "copy-btn",
                      size: "small",
                      text: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (copyJson(staticParsedData.value)))
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode(" 复制 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "json-line-numbers" }, null, -1)),
                    _createElementVNode("pre", {
                      class: "json-code",
                      innerHTML: highlightJson(staticParsedData.value)
                    }, null, 8, _hoisted_12)
                  ])
                ])
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 512),
    _createElementVNode("div", {
      ref_key: "templateStepRef",
      ref: templateStepRef,
      class: _normalizeClass(["step-card anim-card", { disabled: !staticUploaded.value }])
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", {
            class: _normalizeClass(["step-status-dot", 
              dynamicParsedReady.value
                ? 'dot-success'
                : staticUploaded.value
                ? 'dot-pending'
                : 'dot-disabled'
            ])
          }, null, 2),
          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "step-card-title" }, "Step 2", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "step-card-desc" }, "准备动态协议数据", -1)),
          (!staticUploaded.value)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                size: "small",
                type: "info",
                class: "lock-tag"
              }, {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode(" 请先完成 Step 1 ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", {
            class: _normalizeClass(["status-tag", dynamicParsedReady.value ? 'tag-success' : 'tag-idle'])
          }, _toDisplayString(step2StatusLabel.value), 3)
        ])
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: templateTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((templateTab).value = $event)),
        class: "template-tabs fancy-tabs",
        type: "card",
        onTabChange: onTemplateTabChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { name: "export" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Download))
                  ]),
                  _: 1
                }),
                _cache[24] || (_cache[24] = _createElementVNode("span", null, "导出 xlsx", -1))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref_key: "exportPaneRef",
                ref: exportPaneRef,
                class: "tab-pane-inner"
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "template-tip" }, [
                  _createElementVNode("p", null, " 可以下载 CCS 动态协议模板 xlsx 文件，按表格规则填写后，再上传到服务器。 也可以直接上传你之前已经填好的 xlsx 文件，无需重新导出。 "),
                  _createElementVNode("p", { class: "template-tip-small" }, " 模板包含 13 个 sheet：Ship / PowerSys / Charger / Compartment / BatteryGroup / BatteryCluster / BatteryPack / CDSys / CBus / Converter / Motor / Propeller / Rudder ")
                ], -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    disabled: !staticUploaded.value,
                    loading: templateDownloading.value,
                    onClick: downloadDynamicTemplate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { style: {"margin-right":"4px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Download))
                        ]),
                        _: 1
                      }),
                      _cache[25] || (_cache[25] = _createTextVNode(" 导出动态协议模板 ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _createVNode(_component_el_upload, {
                  class: "ccs-upload",
                  drag: "",
                  accept: ".xls,.xlsx",
                  disabled: !staticUploaded.value,
                  "on-change": (file) => handleDynamicFileChange(file),
                  "on-remove": handleDynamicFileRemove,
                  "auto-upload": false,
                  limit: 1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_el_icon, { size: 32 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(UploadFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(staticUploaded.value
                      ? "拖拽或点击上传动态协议文件"
                      : "请先完成 Step 1"), 1),
                      _cache[26] || (_cache[26] = _createElementVNode("p", { class: "upload-hint" }, ".xlsx / .xls", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "on-change"]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    disabled: !staticUploaded.value || !dynamicFile.value,
                    loading: dynamicUploading.value,
                    onClick: uploadDynamicFile
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode(" 上传文件 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  (dynamicFilePath.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createVNode(_component_el_icon, { color: "#67c23a" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Check))
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 已上传：" + _toDisplayString(dynamicFile.value?.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { name: "edit" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_23, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(EditPen))
                  ]),
                  _: 1
                }),
                _cache[29] || (_cache[29] = _createElementVNode("span", null, "在线编辑", -1))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref_key: "editPaneRef",
                ref: editPaneRef,
                class: "tab-pane-inner"
              }, [
                (templateLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_el_icon, { class: "is-loading" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Loading))
                        ]),
                        _: 1
                      }),
                      _cache[30] || (_cache[30] = _createElementVNode("span", null, "正在加载模板规则...", -1))
                    ]))
                  : (templateSheets.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", {
                          ref_key: "sheetListRef",
                          ref: sheetListRef,
                          class: "sheet-list"
                        }, [
                          _createElementVNode("div", {
                            class: "sheet-list-indicator",
                            style: _normalizeStyle(sheetIndicatorStyle.value)
                          }, null, 4),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateSheets.value, (sheet, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: sheet.name,
                              ref_for: true,
                              ref: (el) => setSheetItemRef(el, idx),
                              class: _normalizeClass(["sheet-item", { active: idx === activeSheetIdx.value }]),
                              onClick: ($event: any) => (switchSheet(idx))
                            }, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(String(idx + 1).padStart(2, "0")), 1),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(sheet.name), 1),
                              _createElementVNode("span", _hoisted_29, _toDisplayString(sheet.rows.length) + " 项", 1)
                            ], 10, _hoisted_26))
                          }), 128))
                        ], 512),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("span", _hoisted_33, _toDisplayString(activeSheet.value?.name), 1),
                              _createVNode(_component_el_tag, {
                                size: "small",
                                type: "info",
                                effect: "plain"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(activeSheet.value?.codes
                          ? `数组型 · ${activeSheet.value?.codes?.length} 组`
                          : "对象型"), 1)
                                ]),
                                _: 1
                              }),
                              (
                        activeSheet.value?.sourceColumns &&
                        activeSheet.value.sourceColumns > 1
                      )
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    size: "small",
                                    type: "warning",
                                    effect: "plain"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 值来源 " + _toDisplayString(activeSheet.value?.sourceColumns) + " 列 ", 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "sheet-panel-tip" }, [
                              _createTextVNode(" 仅 "),
                              _createElementVNode("span", { class: "tip-key" }, "值来源"),
                              _createTextVNode(" 列可编辑，其他列已锁定 ")
                            ], -1))
                          ]),
                          _createElementVNode("div", {
                            ref_key: "sheetTableRef",
                            ref: sheetTableRef,
                            class: "sheet-table-wrap"
                          }, [
                            _createElementVNode("table", _hoisted_34, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _cache[32] || (_cache[32] = _createElementVNode("th", { class: "col-key" }, "字段标识", -1)),
                                  _cache[33] || (_cache[33] = _createElementVNode("th", { class: "col-name" }, "字段名称", -1)),
                                  _cache[34] || (_cache[34] = _createElementVNode("th", { class: "col-type" }, "数据类型", -1)),
                                  ((activeSheet.value?.sourceColumns ?? 1) > 1)
                                    ? (_openBlock(), _createElementBlock("th", {
                                        key: 0,
                                        colspan: activeSheet.value?.sourceColumns,
                                        class: "col-source-merged"
                                      }, " 值来源 ", 8, _hoisted_35))
                                    : (_openBlock(), _createElementBlock("th", _hoisted_36, "值来源"))
                                ]),
                                (activeSheet.value?.codes)
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                                      _cache[36] || (_cache[36] = _createElementVNode("td", { class: "locked" }, "Code", -1)),
                                      _cache[37] || (_cache[37] = _createElementVNode("td", { class: "locked" }, "编号", -1)),
                                      _createElementVNode("td", _hoisted_38, [
                                        _createVNode(_component_el_tag, {
                                          size: "small",
                                          effect: "dark"
                                        }, {
                                          default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                            _createTextVNode("S", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeSheet.value.codes, (code, ci) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: ci,
                                          class: "code-cell",
                                          style: _normalizeStyle(cellWidthStyle(ci))
                                        }, _toDisplayString(code), 5))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeSheet.value?.rows ?? [], (row, ri) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: ri,
                                    class: "data-row"
                                  }, [
                                    _createElementVNode("td", _hoisted_39, [
                                      _createElementVNode("span", _hoisted_40, _toDisplayString(row.key), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_41, _toDisplayString(row.name), 1),
                                    _createElementVNode("td", _hoisted_42, [
                                      _createVNode(_component_el_tag, {
                                        size: "small",
                                        type: typeTagType(row.type),
                                        effect: "plain"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(row.type), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["type"])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeSheet.value?.sourceColumns ?? 1, (_, ci) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: ci,
                                        class: "editable-cell",
                                        style: _normalizeStyle(cellWidthStyle(ci))
                                      }, [
                                        _createVNode(_component_el_input, {
                                          modelValue: row.sources[ci],
                                          "onUpdate:modelValue": ($event: any) => ((row.sources[ci]) = $event),
                                          size: "small",
                                          placeholder: "值来源",
                                          class: "cell-input"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ], 4))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ], 512)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_el_button, {
                    plain: "",
                    disabled: !staticUploaded.value || templateLoading.value,
                    onClick: resetCurrentSheet
                  }, {
                    default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                      _createTextVNode(" 重置本页 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_button, {
                    plain: "",
                    type: "danger",
                    disabled: !staticUploaded.value || templateLoading.value,
                    onClick: resetAllSheets
                  }, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode(" 重置全部 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_button, {
                    type: "success",
                    disabled: !staticUploaded.value || templateLoading.value,
                    onClick: confirmOnlineEdit
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createTextVNode(" 确定 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          (parseLoading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_icon, { class: "is-loading" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Loading))
                  ]),
                  _: 1
                }),
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "正在解析协议数据...", -1))
              ], 64))
            : (parseSuccess.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_icon, { color: "#67c23a" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  }),
                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "parse-ok" }, "协议解析成功，可发送报文", -1))
                ], 64))
              : (canParse.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_el_icon, { color: "#e6a23c" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Warning))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(templateTab.value === "export"
                ? "xlsx 已上传，请点击「解析协议」"
                : "在线规则已确定，请点击「解析协议」"), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createVNode(_component_el_icon, { color: "#909399" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(InfoFilled))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(templateTab.value === "export"
                ? "请先上传动态协议 xlsx 文件"
                : "请先编辑并点击「确定」"), 1)
                  ], 64))
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_el_button, {
            type: parseSuccess.value ? 'success' : 'primary',
            disabled: !canParse.value || parseLoading.value || parseSuccess.value,
            loading: parseLoading.value,
            onClick: parseProtocol
          }, {
            default: _withCtx(() => [
              (parseSuccess.value)
                ? (_openBlock(), _createBlock(_component_el_icon, {
                    key: 0,
                    style: {"margin-right":"4px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CircleCheck))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(parseSuccess.value ? "已解析" : "解析协议"), 1)
            ]),
            _: 1
          }, 8, ["type", "disabled", "loading"]),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            disabled: !parseSuccess.value,
            onClick: toggleDynamicPreview
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(dynamicPreviewVisible.value ? "收起解析结果" : "查看解析结果"), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_Transition, { name: "preview-expand" }, {
        default: _withCtx(() => [
          (dynamicParsedData.value && dynamicPreviewVisible.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                ref_key: "dynamicPreviewRef",
                ref: dynamicPreviewRef,
                class: "json-preview-wrap"
              }, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _cache[44] || (_cache[44] = _createElementVNode("span", { class: "json-dot red" }, null, -1)),
                    _cache[45] || (_cache[45] = _createElementVNode("span", { class: "json-dot yellow" }, null, -1)),
                    _cache[46] || (_cache[46] = _createElementVNode("span", { class: "json-dot green" }, null, -1)),
                    _cache[47] || (_cache[47] = _createElementVNode("span", { class: "json-filename" }, "dynamic-protocol.json", -1)),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(jsonLineCount(dynamicParsedData.value)) + " 行 ", 1),
                    _createVNode(_component_el_button, {
                      class: "copy-btn",
                      size: "small",
                      text: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (copyJson(dynamicParsedData.value)))
                    }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createTextVNode(" 复制 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "json-line-numbers" }, null, -1)),
                    _createElementVNode("pre", {
                      class: "json-code",
                      innerHTML: highlightJson(dynamicParsedData.value)
                    }, null, 8, _hoisted_51)
                  ])
                ])
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      ref_key: "dynamicStepRef",
      ref: dynamicStepRef,
      class: _normalizeClass(["step-card anim-card", { disabled: !parseSuccess.value }])
    }, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("span", {
            class: _normalizeClass(["step-status-dot", 
              sendSuccess.value
                ? 'dot-success'
                : parseSuccess.value
                ? 'dot-pending'
                : 'dot-disabled'
            ])
          }, null, 2),
          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "step-card-title" }, "Step 3", -1)),
          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "step-card-desc" }, "发送 CCS 报文", -1)),
          (!parseSuccess.value)
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 0,
                size: "small",
                type: "info",
                class: "lock-tag"
              }, {
                default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                  _createTextVNode(" 请先完成 Step 2 ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("span", {
            class: _normalizeClass(["status-tag", sendSuccess.value ? 'tag-success' : 'tag-idle'])
          }, _toDisplayString(sendSuccess.value ? "已发送" : "未发送"), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _cache[53] || (_cache[53] = _createElementVNode("p", { class: "send-step-hint" }, " 确认协议数据无误后，点击下方按钮将报文发送给 CCS 服务端。 ", -1)),
        _createVNode(_component_el_button, {
          ref: "sendBtnRef",
          type: "success",
          size: "large",
          disabled: !parseSuccess.value || sending.value,
          loading: sending.value,
          onClick: sendReport
        }, {
          default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
            _createTextVNode(" 发送报文 ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 2),
    _createVNode(_component_el_dialog, {
      modelValue: isWaitingVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isWaitingVisible).value = $event)),
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      width: "400px",
      center: ""
    }, {
      default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
        _createElementVNode("div", { class: "waiting-content" }, [
          _createElementVNode("div", { class: "waiting-ring" }),
          _createElementVNode("p", { class: "waiting-title" }, "正在发送报文..."),
          _createElementVNode("p", { class: "waiting-subtitle" }, "请稍候")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["modelValue"])
  ], 512))
}
}

})